import { Link } from "react-router-dom";

const MESSENGER_URL =
  "https://m.me/jglennverano?text=Hi%20I%20want%20to%20ask%20about%20my%20car%20loan%20options";

const quickLinks = [
  { label: "How It Works", href: "#how" },
  { label: "Why Choose Us", href: "#benefits" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="w-full rounded-t-3xl"
      style={{
        background: "linear-gradient(135deg, #1D4ED8 0%, #3B82F6 100%)",
      }}
    >
      {/* Main content */}
      <div className="mx-auto max-w-7xl px-6 pt-16 pb-12 lg:px-10 lg:pt-20">
        <div className="grid gap-12 lg:grid-cols-3 lg:gap-16">

          {/* ── LEFT: Brand + Trust ── */}
          <div className="flex flex-col">
            <img
              src="https://public.readdy.ai/ai/img_res/edited_24ec1a8935e927938c764a237761f43e_29c252ee.jpg"
              alt="AutoManagement PH"
              className="h-14 w-auto object-contain mb-5"
              style={{
                mixBlendMode: "multiply",
                imageRendering: "crisp-edges",
              }}
            />
            <p
              className="text-sm leading-7 max-w-xs"
              style={{ color: "#E5E7EB" }}
            >
              Helping vehicle owners in the Philippines navigate car loan exit
              options with clarity and confidence.
            </p>

            <div className="mt-5 flex items-center gap-2">
              <div className="flex h-5 w-5 items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-2-line text-sm" style={{ color: "#93C5FD" }} />
              </div>
              <span className="text-sm" style={{ color: "#BFDBFE" }}>
                Cebu City, Philippines
              </span>
            </div>

            {/* Trust badges */}
            <div className="mt-6 flex flex-wrap gap-2">
              {["Legal & Compliant", "Confidential", "PH-Based"].map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.12)",
                    color: "#E0F2FE",
                  }}
                >
                  <i className="ri-checkbox-circle-line text-xs" />
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* ── MIDDLE: Quick Links ── */}
          <div>
            <h4
              className="mb-5 text-xs font-bold uppercase tracking-widest"
              style={{ color: "#93C5FD" }}
            >
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="inline-flex items-center gap-2 text-sm font-medium transition-all duration-150 cursor-pointer group"
                    style={{ color: "#E5E7EB" }}
                    onMouseEnter={(e) => {
                      const el = e.currentTarget as HTMLElement;
                      el.style.color = "#FFFFFF";
                      el.style.textDecoration = "underline";
                    }}
                    onMouseLeave={(e) => {
                      const el = e.currentTarget as HTMLElement;
                      el.style.color = "#E5E7EB";
                      el.style.textDecoration = "none";
                    }}
                  >
                    <i className="ri-arrow-right-s-line text-xs opacity-60" />
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/intake"
                  className="inline-flex items-center gap-2 text-sm font-medium transition-all duration-150 cursor-pointer"
                  style={{ color: "#E5E7EB" }}
                  onMouseEnter={(e) => {
                    const el = e.currentTarget as HTMLElement;
                    el.style.color = "#FFFFFF";
                    el.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    const el = e.currentTarget as HTMLElement;
                    el.style.color = "#E5E7EB";
                    el.style.textDecoration = "none";
                  }}
                >
                  <i className="ri-arrow-right-s-line text-xs opacity-60" />
                  Get Free Review
                </Link>
              </li>
            </ul>
          </div>

          {/* ── RIGHT: Contact + CTA ── */}
          <div>
            <h4
              className="mb-5 text-xs font-bold uppercase tracking-widest"
              style={{ color: "#93C5FD" }}
            >
              Get Help
            </h4>

            <ul className="space-y-4 mb-7">
              {/* Phone */}
              <li className="flex items-center gap-3">
                <div
                  className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg"
                  style={{ backgroundColor: "rgba(255,255,255,0.12)" }}
                >
                  <i className="ri-phone-line text-sm text-white" />
                </div>
                <div>
                  <div className="text-xs" style={{ color: "#93C5FD" }}>
                    Call / Viber / WhatsApp
                  </div>
                  <div className="text-sm font-semibold text-white">
                    +63 XXX XXX XXXX
                  </div>
                </div>
              </li>

              {/* Facebook */}
              <li className="flex items-center gap-3">
                <div
                  className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg"
                  style={{ backgroundColor: "rgba(255,255,255,0.12)" }}
                >
                  <i className="ri-facebook-fill text-sm text-white" />
                </div>
                <div>
                  <div className="text-xs" style={{ color: "#93C5FD" }}>
                    Facebook Page
                  </div>
                  <a
                    href="https://www.facebook.com/cebuautomanagement"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-semibold text-white cursor-pointer transition-all duration-150"
                    onMouseEnter={(e) => {
                      const el = e.currentTarget as HTMLElement;
                      el.style.textDecoration = "underline";
                      el.style.opacity = "0.85";
                    }}
                    onMouseLeave={(e) => {
                      const el = e.currentTarget as HTMLElement;
                      el.style.textDecoration = "none";
                      el.style.opacity = "1";
                    }}
                  >
                    Message us on Facebook
                  </a>
                </div>
              </li>
            </ul>

            {/* Messenger CTA button */}
            <a
              href={MESSENGER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 whitespace-nowrap rounded-full px-6 py-3 text-sm font-bold transition-all duration-200 cursor-pointer"
              style={{
                backgroundColor: "#FFFFFF",
                color: "#1D4ED8",
                boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.backgroundColor = "#EFF6FF";
                el.style.transform = "translateY(-2px)";
                el.style.boxShadow = "0 6px 20px rgba(0,0,0,0.22)";
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.backgroundColor = "#FFFFFF";
                el.style.transform = "translateY(0)";
                el.style.boxShadow = "0 4px 16px rgba(0,0,0,0.18)";
              }}
            >
              <span className="flex h-5 w-5 items-center justify-center flex-shrink-0">
                <i className="ri-messenger-fill text-base" />
              </span>
              Chat on Messenger
            </a>

            <p className="mt-3 text-xs" style={{ color: "#BFDBFE" }}>
              Usually replies within a few minutes
            </p>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        className="mx-auto max-w-7xl px-6 lg:px-10"
        style={{ borderTop: "1px solid rgba(255,255,255,0.15)" }}
      >
        <div className="flex flex-col gap-2 py-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs" style={{ color: "#BFDBFE" }}>
            &copy; {year} AutoManagement PH. All rights reserved.
          </p>
          <p className="text-xs sm:text-right" style={{ color: "#93C5FD" }}>
            Advisory support only. Results may vary.
          </p>
        </div>
      </div>
    </footer>
  );
}